module.exports = __webpack_public_path__ + "img/GMB.fcc34b98.svg";